module.exports = "/images/up-arrow.svg?d36cdb523be91e7a164efdd50b5ddfde";